import React, { useState } from 'react'
const ShowMulDiv = ({ row, mat, ques, ans, ch, Reminder }) => {
    const [display, setdisplay] = useState(1)
    const anskey = []
    const Userans = []
    const matArg = []
    let temp = 1;
    let temp1;
    let temp2;
    ans.map((i) => {
        Userans.push(i)
    })
    let len = Userans.length;
    for (let i = 0; i < len; i++) {
        matArg.push(mat[i])
    }
    if (ch == "d") {
        for (let i = 0; i < len; i++) {
            if (Reminder) {
                temp = mat[i][0] % mat[i][1]
            } else {
                temp = mat[i][0] / mat[i][1]
            }
            anskey.push(temp)
            temp = 0
        }
    } else {
        matArg.map((i) => {
            i.map((j) => {
                temp *= j;
            })
            anskey.push(temp)
            temp = 1;
        })
    }
    const reloadFun = (event) => {
        window.location.reload()


    }
    return (
        // <div className="display">
        <div className={display ? "display" : ".hide-btn"}>

            <div className='X-btn' onClick={() => { reloadFun() }}>X</div>
            {/* <div ref={targetRef}> */}
            <div className={"mat-show-mul"}>
                <div className='X-mat-show'></div>
                <div className='mat-row-mul'>
                    <table>
                        <tr>
                            <th>{ch == "d" ? "Dividend" : ""}</th>
                            <th>{ch == "d" ? "Divisor" : ""}</th>
                            <th> {ch == "d" ? "Correct Ans" : ""}</th>
                            <th>{ch == "d" ? "User Ans" : ""} </th>
                        </tr>
                        {matArg.map((row, i) => (
                            <tr key={i} className='mul'>
                                {row.map((cell, j) => (<td className='color'>{cell}</td>))}
                                <td className={ans ? anskey[i] == ans[i] ? "crt" : "wrng" : ""}>{ans[i] ? anskey[i] : ""}</td>
                                <td className={ans ? anskey[i] == ans[i] ? "crt" : "wrng" : ""}>{ans[i]}</td>
                                {/* <div className    ='color'>{ans[i]}</div> */}
                                <br />
                            </tr>
                        ))}
                    </table>
                </div>
            </div>
        </div>
    )
}
export default ShowMulDiv 